import React, { memo } from "react";
import SidebarBoxContainer from "../SidebarBoxContainer";
import DescriptionIcon from "@mui/icons-material/Description";
import { styled } from "@mui/material/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
var MetadataItemDiv = styled("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    display: "flex",
    flexDirection: "row",
    marginBottom: ".5em",
    "& > label": {
      fontSize: "1rem",
      marginBottom: ".5em",
      textTransform: "capitalize",
      wordWrap: "break-word"
    },
    label: {
      width: "50%"
    },
    select: {
      width: "100%"
    }
  };
});

var MetadataItem = function MetadataItem(_ref2) {
  var _metadataConfig$optio, _metadataConfig$optio2;

  var name = _ref2.name,
      value = _ref2.value,
      metadataId = _ref2.metadataId,
      imageIndex = _ref2.imageIndex,
      groupId = _ref2.groupId,
      onChange = _ref2.onChange,
      _ref2$metadataConfig = _ref2.metadataConfig,
      metadataConfig = _ref2$metadataConfig === void 0 ? {} : _ref2$metadataConfig;

  var handleChange = function handleChange(e) {
    e.preventDefault();
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
    onChange({
      name: name,
      value: value,
      imageIndex: imageIndex,
      groupId: groupId,
      metadataId: metadataId
    });
  };

  return React.createElement(MetadataItemDiv, null, React.createElement("label", {
    for: name
  }, name), React.createElement("div", {
    style: {
      width: "50%"
    }
  }, (metadataConfig === null || metadataConfig === void 0 ? void 0 : metadataConfig.selectable) !== true && React.createElement(React.Fragment, null, React.createElement("input", {
    type: "text",
    value: value,
    name: name,
    onChange: handleChange,
    id: name,
    list: "".concat(name, "-list"),
    style: {
      width: "100%"
    }
  }), React.createElement("datalist", {
    id: "".concat(name, "-list")
  }, metadataConfig === null || metadataConfig === void 0 ? void 0 : (_metadataConfig$optio = metadataConfig.options) === null || _metadataConfig$optio === void 0 ? void 0 : _metadataConfig$optio.map(function (opt) {
    if (opt.value && opt.label) {
      return React.createElement("option", {
        key: opt.value,
        value: opt.value
      }, opt.label);
    }

    return React.createElement("option", {
      key: opt,
      value: opt
    });
  }))), (metadataConfig === null || metadataConfig === void 0 ? void 0 : metadataConfig.selectable) === true && React.createElement("select", {
    name: name,
    id: name,
    onChange: handleChange,
    style: {
      width: '100%'
    }
  }, metadataConfig === null || metadataConfig === void 0 ? void 0 : (_metadataConfig$optio2 = metadataConfig.options) === null || _metadataConfig$optio2 === void 0 ? void 0 : _metadataConfig$optio2.map(function (opt) {
    if (opt.value && opt.label) {
      return React.createElement("option", {
        key: opt.value,
        value: opt.value,
        selected: opt.value === value
      }, opt.label);
    }

    return React.createElement("option", {
      key: opt,
      value: opt
    });
  }))));
};

var MetadataList = function MetadataList(_ref3) {
  var title = _ref3.title,
      metadata = _ref3.metadata,
      imageIndex = _ref3.imageIndex,
      onMetadataChange = _ref3.onMetadataChange,
      _ref3$metadataConfigs = _ref3.metadataConfigs,
      metadataConfigs = _ref3$metadataConfigs === void 0 ? [] : _ref3$metadataConfigs,
      groupId = _ref3.groupId;
  return React.createElement("div", null, React.createElement("h2", null, title), metadata && metadata.map(function (_ref4) {
    var key = _ref4.key,
        value = _ref4.value,
        metadataId = _ref4.metadataId;
    return React.createElement(MetadataItem, {
      name: key,
      value: value,
      imageIndex: imageIndex,
      metadataId: metadataId,
      groupId: groupId,
      onChange: onMetadataChange,
      metadataConfig: metadataConfigs.find(function (i) {
        return i.key === key;
      })
    });
  }));
};

var theme = createTheme();
var DivContainer = styled("div")(function (_ref5) {
  var theme = _ref5.theme;
  return {
    paddingLeft: 16,
    paddingRight: 16,
    fontSize: 12,
    "& h1": {
      fontSize: 18
    },
    "& h2": {
      fontSize: 14
    },
    "& h3": {
      fontSize: 12
    },
    "& h4": {
      fontSize: 12
    },
    "& h5": {
      fontSize: 12
    },
    "& h6": {
      fontSize: 12
    },
    "& p": {
      fontSize: 12
    },
    "& a": {},
    "& img": {
      width: "100%"
    }
  };
});
export var MetadataEditorSidebarBox = function MetadataEditorSidebarBox(_ref6) {
  var _state$images$state$s, _state$images$state$s2, _state$images$state$s3, _state$images$state$s4;

  var state = _ref6.state,
      onMetadataChange = _ref6.onMetadataChange;
  var metadataConfigs = state.metadataConfigs || [];
  var selectedPhotoMetadata = state === null || state === void 0 ? void 0 : (_state$images$state$s = state.images[state.selectedImage]) === null || _state$images$state$s === void 0 ? void 0 : _state$images$state$s.metadata;
  var selectedGroupId = state === null || state === void 0 ? void 0 : (_state$images$state$s2 = state.images[state.selectedImage]) === null || _state$images$state$s2 === void 0 ? void 0 : (_state$images$state$s3 = _state$images$state$s2.regions) === null || _state$images$state$s3 === void 0 ? void 0 : (_state$images$state$s4 = _state$images$state$s3.find(function (r) {
    return r.highlighted === true;
  })) === null || _state$images$state$s4 === void 0 ? void 0 : _state$images$state$s4.groupId;
  var articleMetadata = []; // example: [{key: "previousArticleId", value "123-123-123-123-123"}]

  if (selectedGroupId !== undefined) {
    var articleMetadataRegion = state === null || state === void 0 ? void 0 : state.images[state.selectedImage].regions.find(function (r) {
      return r.cls === 'metadata' && "".concat(r.groupId) === selectedGroupId;
    });

    if (articleMetadataRegion) {
      var metadata = JSON.parse(articleMetadataRegion.text);
      articleMetadata = metadata;
    }
  }

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(SidebarBoxContainer, {
    title: "Metadata",
    icon: React.createElement(DescriptionIcon, {
      style: {
        color: grey[700]
      }
    }),
    expandedByDefault: true
  }, React.createElement(DivContainer, {
    style: {
      height: "600px"
    }
  }, articleMetadata.length > 0 && React.createElement(MetadataList, {
    title: "Article",
    metadata: articleMetadata,
    imageIndex: state.selectedImage,
    groupId: selectedGroupId,
    onMetadataChange: onMetadataChange,
    metadataConfigs: metadataConfigs.filter(function (mfc) {
      return mfc.level === 'photo_metadata-engine';
    })
  }), selectedPhotoMetadata && React.createElement(MetadataList, {
    title: "Page",
    metadata: selectedPhotoMetadata,
    imageIndex: state.selectedImage,
    onMetadataChange: onMetadataChange,
    metadataConfigs: metadataConfigs.filter(function (mfc) {
      return mfc.level === 'photo';
    })
  }), React.createElement(MetadataList, {
    title: "Issue",
    metadata: state.albumMetadata,
    onMetadataChange: onMetadataChange,
    id: "metadata-album",
    metadataConfigs: metadataConfigs.filter(function (mfc) {
      return mfc.level === 'album';
    })
  }))));
};
export default memo(MetadataEditorSidebarBox);